export default {
    getAllFheTickets: env => {
        return {
            url: `/${env}/ticket`,
            method: 'GET',
        };
    },
    getFheTicketDetails: (env, ticketId) => {
        return {
            url: `/${env}/ticket/:ticketId`,
            method: 'GET',
            route_params: {
                ticketId,
            },
        };
    },
    updateFheTicketState: (env, ticketId, ticketState) => {
        return {
            url: `/${env}/ticket/:ticketId/updateState`,
            method: 'PATCH',
            route_params: {
                ticketId,
            },
            patch_params: {
                ticketState: ticketState,
            },
        };
    },
    getFheTicketHistory: (env, ticketId, offset, limit) => {
        return {
            url: `/${env}/ticket/:ticketId/history`,
            method: 'GET',
            route_params: {
                ticketId,
            },
            get_params: {
                offset,
                limit,
            },
        };
    },
    deleteFheTicketHistory: (env, id, ticketId) => {
        return {
            url: `/${env}/ticket/delete`,
            method: 'PATCH',
            patch_params: {
                id,
                ticketId,
            },
        };
    },
    addFheTicketHistoryMessage: (env, ticketId, message) => {
        return {
            url: `/${env}/ticket/:ticketId/add`,
            method: 'POST',
            route_params: {
                ticketId,
            },
            post_params: {
                message,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/TicketFhe/api.js